module.exports = __webpack_public_path__ + "static/media/flying_through_space_100.3333093b.ico";